import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Viewpass from "./Viewpass";
import RegisterFace from "./RegisterFace";
import Modal from "react-bootstrap/Modal";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { format } from "date-fns";
import {
  addstop,
  boardinghistory,
  getPassLogListApi,
  passhistory,
} from "../../services/Employeeservice";
import { toast } from "react-toastify";

const Employeedashboard = () => {
  const navigate = useNavigate();
  const [checkpass, setCheckpass] = useState(false);
  const [show, setShow] = useState(false);
  const [location, setLocation] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [historydata, setHistorydata] = useState([]);
  const [passLogData, setPassLogData] = useState([]);
  const [passLogLoading, setPassLogLoading] = useState(false);
  const [historyloading, setHistoryloading] = useState(false);
  const [boardinginfo, setBoardinginfo] = useState([]);

  const reset = () => {
    setLocation("");
    setComment("");
  };

  const handlesubmit = () => {
    setLoading(true);
    const payload = {
      requested_location_description: location,
      comment: comment,
    };
    addstop(payload)
      .then((res) => {
        reset();
        setShow(false);
        toast.success("Request Submitted Successfully");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.[0] || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };



  const gethistorydata = () => {
    setHistoryloading(true);
    passhistory()
      .then((res) => {
        const results = res?.data?.results?.results || [];
        setHistorydata(results);

        // Check if there's an active pass
        const hasActivePass = results.some((pass) => pass.status === "Active");
        setCheckpass(hasActivePass);

        console.log("Pass history data", results);
      })
      .catch((err) => {
        console.error("Pass history error", err);
        toast.error(
          err?.response?.data?.message || "Failed to load pass history"
        );
        setCheckpass(false);
      })
      .finally(() => {
        setHistoryloading(false);
      });
  };

  const boardingdata = () => {
    boardinghistory()
      .then((res) => {
        const logs = Array.isArray(res?.data?.results?.results)
          ? res.data.results.results
          : [];
        console.log("Boarding logs:", logs); // Debug log
        setBoardinginfo(logs);
      })
      .catch((err) => {
        console.error("Boarding data error", err);
        toast.error("Failed to fetch boarding data");
      });
  };

  const getPassLogDataList = () => {
    setPassLogLoading(true);
    getPassLogListApi()
      .then((res) => {
        const results = res?.data?.results?.results || [];
        setPassLogData(results);
        console.log("Pass history data", results);
      })
      .catch((err) => {
        console.error("Pass history error", err);
        toast.error(
          err?.response?.data?.message || "Failed to load pass history"
        );
      })
      .finally(() => {
        setPassLogLoading(false);
      });
  };

  useEffect(() => {
    gethistorydata();
    boardingdata(); // <- This now uses the fixed version
    getPassLogDataList()
  }, []);

  // Pass History Columns
  const historyColumns = [
    {
      name: "Pass ID",
      selector: (row) => row?.pass_id || "-",
      wrap: true,
    },
    {
      name: "Route",
      selector: (row) => {
        const name = row?.route?.name;
        const number = row?.route?.route_number;
        return name && number ? `${name} (${number})` : name || "-";
      },
      wrap: true,
      grow: 2,
    },
    {
      name: "Shift",
      selector: (row) => {
        if (!row.shift) return "-";
        const startTime = row.shift.start_time;
        const endTime = row.shift.end_time;

        try {
          const start = new Date(`1970-01-01T${startTime}`);
          const end = new Date(`1970-01-01T${endTime}`);
          return `${row.shift.name} [${format(start, "h:mm a")} - ${format(
            end,
            "h:mm a"
          )}]`;
        } catch {
          return row.shift.name || "-";
        }
      },
      wrap: true,
    },
    {
      name: "Issue Date",
      selector: (row) => {
        try {
          return row?.start_date
            ? format(new Date(row.start_date), "d MMM yyyy")
            : "-";
        } catch {
          return "-";
        }
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Cancel Date",
      selector: (row) => {
        try {
          return row?.pass_cancel_date
            ? format(new Date(row.pass_cancel_date), "d MMM yyyy")
            : "-";
        } catch {
          return "-";
        }
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status || "-",
      width: "130px",
      cell: (row) => (
        <span
          className={`badge text-bg-${row?.status?.toLowerCase() === "active"
            ? "success-soft"
            : "danger-soft"
            }`}
        >
          {row.status}
        </span>
      ),
    },
  ];


  const PassLogColumns = [
    {
      name: "Pass ID",
      selector: (row) => row?.bus_pass ? row.bus_pass.pass_id : "NONE",
      wrap: true,
    },
    {
      name: "Route",
      selector: (row) => {
        if (row.route) {
          const name = row?.route?.name;
          const number = row?.route?.route_number;
          return name && number ? `${name} (${number})` : name || "-";
        }
        return "NONE"

      },
      wrap: true,
      grow: 2,
    },
    {
      name: "Shift",
      selector: (row) => {
        return row?.shift ? row.shift.name : "NONE";
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Stop",
      selector: (row) => {
        return row?.stop ? row.stop.name : "NONE";
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Last Change",
      selector: (row) => {
        try {
          return row?.updated_at
            ? format(new Date(row.updated_at), "d MMM yyyy h:mm a")
            : "-";
        } catch {
          return "-";
        }
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.log_status || "-",
      width: "130px",
      cell: (row) => (
        <span
          className={`badge text-bg-primary-soft`}
        >
          {row.log_status}
        </span>
      ),
    },
  ];

  // Boarding Log Columns
  const boardingcolumns = [
    {
      name: "Bus",
      selector: (row) => row?.bus_registration_number,
      sortable: true,
      wrap: true,
    },
    {
      name: "Time",
      selector: (row) => format(new Date(row.timestamp), "d MMMM yyyy, h:mma"),
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "Stop",
      selector: (row) => row?.stop_name || "-",
      grow: 2,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge ${row.status === "Active" ? "bg-success" : "bg-secondary"
            }`}
        >
          {row.status}
        </span>
      ),
      sortable: true,
    },
  ];

  return (
    <div className="row">
      {checkpass && (
        <div className="col-12 d-flex justify-content-end gap-1">
          <button
            className="btn btn-dark"
            onClick={() => navigate("/employee/passchange")}
          >
            Request for Stop change
          </button>
        </div>
      )}


      <div className="col-12 col-md-6 mt-2">
        <Viewpass gethistorydata={gethistorydata} setCheckpass={setCheckpass} />
      </div>

      <div className="col-12 col-md-6 mt-2">
        <div className="card">
          <div className="p-2">
            <span className="text-primary fw-semibold">Boarding Log</span>
          </div>
          <div
            className="card-body p-0"
            style={{
              minHeight: "240px",
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            <DataTable
              columns={boardingcolumns}
              data={boardinginfo}
              responsive
              fixedHeader
              fixedHeaderScrollHeight="300px"
              noDataComponent={
                <div className="p-2">There are no records found.</div>
              }
              sortIcon={<div className="data-table-sorter"></div>}
              progressPending={historyloading}
              progressComponent={
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              }
            />
          </div>
        </div>
      </div>

      <div className="col-12 mt-2">
        <div className="card">
          <div className="p-2">
            <span className="text-primary fw-semibold">Pass History</span>
          </div>
          <div className="card-body p-0">
            <DataTable
              columns={historyColumns}
              data={historydata}
              responsive
              noDataComponent={
                <div className="p-2">There are no records found.</div>
              }
              sortIcon={<div className="data-table-sorter" />}
              progressPending={historyloading}
              progressComponent={
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              }
            />
          </div>
        </div>
      </div>

      <div className="col-12 mt-2">
        <div className="card">
          <div className="p-2">
            <span className="text-primary fw-semibold">Recent Pass Logs</span>
          </div>
          <div className="card-body p-0">
            <DataTable
              columns={PassLogColumns}
              data={passLogData}
              responsive
              noDataComponent={
                <div className="p-2">There are no records found.</div>
              }
              sortIcon={<div className="data-table-sorter" />}
              progressPending={historyloading}
              progressComponent={
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              }
            />
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="col-12 col-md-6">
          <RegisterFace />
        </div>
      </div>

      <Modal
        show={show}
        onHide={() => {
          reset();
          setShow(false);
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            New Stop Request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <label className="form-label">Location</label>
              <input
                type="text"
                className="form-control"
                placeholder="Location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handlesubmit()}
              />
            </div>
            <div className="col-12 mt-2">
              <label className="form-label">Comment</label>
              <input
                type="text"
                className="form-control"
                placeholder="Comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handlesubmit()}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
            <button
              className="btn btn-outline-danger"
              onClick={() => {
                reset();
                setShow(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handlesubmit}
              disabled={!(location && comment) || loading}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" />
                  <span className="ms-1">Loading...</span>
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Employeedashboard;
